interface WaitingRoomCacheData {
  code: string;
  timestamp: number;
  id: number;
  isPriority: boolean;
}

const CACHE_KEY = "waitingRoomStatus";
const CACHE_DURATION = 2 * 60 * 60 * 1000; // 2 hours in milliseconds

export const setWaitingRoomCache = (data: {
  code: string;
  id: number;
  isPriority: boolean;
}): void => {
  const cacheData: WaitingRoomCacheData = {
    ...data,
    timestamp: Date.now(),
  };
  localStorage.setItem(CACHE_KEY, JSON.stringify(cacheData));
};

export const getWaitingRoomCache = (): WaitingRoomCacheData | null => {
  try {
    const cached = localStorage.getItem(CACHE_KEY);
    if (!cached) return null;

    const data: WaitingRoomCacheData = JSON.parse(cached);
    const now = Date.now();

    // Check if cache is expired (2 hours)
    if (now - data.timestamp > CACHE_DURATION) {
      localStorage.removeItem(CACHE_KEY);
      return null;
    }

    return data;
  } catch (error) {
    console.error("Error reading waiting room cache:", error);
    localStorage.removeItem(CACHE_KEY);
    return null;
  }
};

export const clearWaitingRoomCache = (): void => {
  localStorage.removeItem(CACHE_KEY);
};

export const isInWaitingRoom = (): boolean => {
  return getWaitingRoomCache() !== null;
};
